import React, { useState, useEffect } from "react";
import { LogIn, ExternalLink, CheckCircle, Package } from "lucide-react";
import images from "../constants/images";
import { useLocation } from "react-router-dom";
import "./NewThankyouPage.css";

function NewThankyouPage() {
  const [countdown, setCountdown] = useState(2.5);
  const [showContent, setShowContent] = useState(false);
  const location = useLocation();
  const { order_id, product_category_name, product_name, unique_id, first_name, last_name, email ,phone_number, state_name, state_code, city, postal_code, address} = location.state || {};

  const currentDomain = window.location.hostname;
  let memberPortalUrl = "https://member.coreagerx.com/";

  if (currentDomain === "checkout.coreagerx.com") {
    memberPortalUrl = "https://member.coreagerx.com/";
  } else if (currentDomain === "checkoutdev-coreagerx.wlmd.dev") {
    memberPortalUrl = "https://mpdev-coreagerx.wlmd.dev/";
  }

  // Determine med parameter based on product name
  const getMedValue = () => {
    if (!product_name) return "";
    const productNameLower = product_name.toLowerCase();
    if (productNameLower.includes("semaglutide")) {
      return "S";
    } else if (productNameLower.includes("tirzepatide")) {
      return "T";
    }
    return "";
  };

  const medValue = getMedValue();
  const medParam = medValue ? `&med=${medValue}` : "";

  // Recover from state or localStorage
  const addOrderId = (value, ids) => {
    if (value == null || value === "") return;
    if (Array.isArray(value)) {
      value.forEach((item) => addOrderId(item, ids));
      return;
    }
    if (typeof value === "object") {
      addOrderId(value.order_id ?? value.id, ids);
      return;
    }
    String(value)
      .split(",")
      .map((orderId) => orderId.trim())
      .filter(Boolean)
      .forEach((orderId) => {
        if (!ids.includes(orderId)) ids.push(orderId);
      });
  };
  const orderIdList = [];
  addOrderId(location.state?.order_ids, orderIdList);
  addOrderId(location.state?.order_id, orderIdList);
  addOrderId(new URLSearchParams(location.search).get("order_ids"), orderIdList);
  if (orderIdList.length === 0) {
    try {
      addOrderId(JSON.parse(sessionStorage.getItem("checkout_order_ids") || "[]"), orderIdList);
    } catch (error) {
      addOrderId(sessionStorage.getItem("checkout_order_ids"), orderIdList);
    }
  }
  const isMultiOrder = orderIdList.length > 1;
  const orderId = orderIdList.join(",") || location.state?.order_id || localStorage.getItem("order_id") || "";
  const uniqueId =
    location.state?.unique_id || localStorage.getItem("unique_id");
  const productCategory =
    location.state?.product_category_name ||
    localStorage.getItem("product_category_name");
  const showIntake = !isMultiOrder && productCategory === "Weight Loss";

  const targetUrl = showIntake
      ? `https://coreagerx.com/onboarding/?order_id=${order_id}&unique_id=${unique_id}&op=intake&fullName[0]=${first_name}&fullName[1]=${last_name}&email=${email}&phone=${phone_number}&usState=${state_name} (${state_code})&address[city]=${city}&address[postal]=${postal_code}&address[addr_line1]=${address}${medParam}`
      : memberPortalUrl;

  useEffect(() => {
    setTimeout(() => setShowContent(true), 100);

    if (order_id && showIntake) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 0.1) {
            clearInterval(timer);
            window.location.replace(targetUrl);
            return 0;
          }
          return prev - 0.1;
        });
      }, 100);

      return () => clearInterval(timer);
    }
  }, [order_id, showIntake, targetUrl]);

  return (
    <div className="thankyou-page">
      <div className={`thankyou-container ${showContent ? "" : "hidden"}`}>
        <div className="thankyou-background">
          <div className="thankyou-background-circle-1"></div>
          <div className="thankyou-background-circle-2"></div>
        </div>

        <div className="thankyou-logo-container">
          <img
            src={images.logo}
            alt="Logo"
            className="thankyou-logo"
          />
        </div>

        <div className="thankyou-icon-container">
          <div className={`thankyou-icon-wrapper ${showContent ? "" : "hidden"}`}>
            <div className="thankyou-icon-pulse"></div>
            <CheckCircle className="thankyou-icon" />
          </div>
        </div>

        <div className="thankyou-content">
          <h1 className="thankyou-title">
            Order Successful!
          </h1>
          <div className="thankyou-content-inner">
            {isMultiOrder ? (
              <div className="thankyou-orders-card">
                <p className="thankyou-orders-label">Your order IDs</p>
                <div className="thankyou-orders-rows">
                  {orderIdList.map((value, index) => (
                    <div className="thankyou-orders-row" key={value}>
                      <span className="thankyou-orders-index">{index + 1}</span>
                      <span className="thankyou-orders-id">{value}</span>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="thankyou-order-list">
                {orderIdList.map((value) => (
                  <div className="thankyou-order-box" key={value}>
                    <div className="thankyou-order-info">
                      <Package className="thankyou-order-icon" />
                      <span className="thankyou-order-id">Order ID : {value}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <p className="thankyou-message">
              Thank you for your purchase! Your order has been successfully
              placed, and a confirmation email has been sent to you. Along with
              this email, we have also sent your member portal credentials and
              login details. Please log in for more information. If you have any
              questions, feel free to reach out to our support team. We
              appreciate your trust and look forward to serving you again!
            </p>
          </div>
        </div>

        <div className="thankyou-buttons">
          {showIntake ? (
            <button
              className="thankyou-button thankyou-button-gray"
              onClick={() =>
                (window.location.href = `https://coreagerx.com/onboarding/?order_id=${orderId}&unique_id=${uniqueId}&op=intake&fullName[0]=${first_name}&fullName[1]=${last_name}&email=${email}&phone=${phone_number}&usState=${state_name} (${state_code})&address[city]=${city}&address[postal]=${postal_code}&address[addr_line1]=${address}${medParam}`)
              }
            >
              <ExternalLink className="thankyou-button-icon" />
              <span>Complete Your Medical Intake</span>
            </button>
          ) : (
            <button
              className="thankyou-button thankyou-button-dark"
              onClick={() => (window.location.href = memberPortalUrl)}
            >
              <LogIn className="thankyou-button-icon" />
              <span>Member Portal Login</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default NewThankyouPage;
